import React from 'react'

const Submissions = () => {
  return (
    <div>Submissions</div>
  )
}

export default Submissions